export const KhanmigoDefault = ({size}: {size: number}) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.61 12.88H38.45C41.22 12.88 43.47 15.13 43.47 17.89V40.57C43.47 42.76 40.86 43.90 39.25 42.41L37.57 40.85C37.10 40.42 36.49 40.18 35.86 40.18H15.11C13.72 40.18 12.60 39.05 12.60 37.67V17.89C12.60 15.13 14.85 12.88 17.61 12.88Z"
                fill="#DEAE93"
            />
            <circle cx="21.4178" cy="27.8582" r="6.01791" fill="white" />
            <mask
                id="mask0_3076_150593"
                style={{maskType: "alpha"}}
                maskUnits="userSpaceOnUse"
                x="15"
                y="21"
                width="13"
                height="13"
            >
                <circle cx="21.4178" cy="27.8582" r="6.01791" fill="white" />
            </mask>
            <g mask="url(#mask0_3076_150593)">
                <circle cx="17.22" cy="23.673" r="5.46" fill="black" />
            </g>
            <circle cx="34.578" cy="27.8579" r="6.01791" fill="white" />
            <mask
                id="mask1_3076_150593"
                style={{maskType: "alpha"}}
                maskUnits="userSpaceOnUse"
                x="28"
                y="21"
                width="13"
                height="13"
            >
                <circle cx="34.578" cy="27.8579" r="6.01791" fill="white" />
            </mask>
            <g mask="url(#mask1_3076_150593)">
                <circle cx="30.3802" cy="23.6728" r="5.46" fill="black" />
            </g>
        </svg>
    );
};
